import upsell from "../upsell"
import primer from "../primer"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("shopping_list_and_premium"),
  ...primer(),

  onInit() {
    this.store.values.hideApm = false
    this.initUpsell()
    this.addConfirmationEventListener()
    this.initPrimer({
      checkoutCompletePath: this.getThankYouPath(),
    })
  },
})
